module.exports = __webpack_public_path__ + "img/01-big.3fb736cf.png";